import { render, staticRenderFns } from "./myPdfView.vue?vue&type=template&id=2505b5f2&scoped=true"
import script from "./myPdfView.vue?vue&type=script&lang=js"
export * from "./myPdfView.vue?vue&type=script&lang=js"
import style0 from "./myPdfView.vue?vue&type=style&index=0&id=2505b5f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505b5f2",
  null
  
)

export default component.exports